import React from "react";
import Avatar from "react-initials-avatar";
import { FaPlus } from "react-icons/fa";
import useTitanApp from "../../hooks/useTitanApp";
import { Tooltip } from "@mui/material";
import {
  setShowInviteTeamSideModal,
  setShowPermissionMessage,
  setShowPermissionModal,
} from "../../dispatchers/appDispatchers";
import InviteTeamSide from "../Invite/InviteTeamSide";
import { checkUserPermissions } from "@/utils/checkUserPermissions";
import {
  accessTitanversUserUpsert,
  accessTitanverseTeamView,
} from "../../data/constantStrings";
import {
  setShowSettingsModal,
  setSettingsActiveTab,
} from "@/dispatchers/appDispatchers";
import { useSettingsTabSwitcher } from "@/lib/settingsData";
export default function TeamMembersSide({
  headerTeamMembers,
  team,
  handleClickedTeam,
}) {
  const { appState } = useTitanApp();
  const { showInviteTeamSideModal } = appState || {};
  const teamMemberstoShow = headerTeamMembers?.slice(0, 4) || [];
  const teamMemberstoHide = headerTeamMembers?.slice(4) || [];
  const { switchTabWithData } = useSettingsTabSwitcher();
  const hasUserPermission = checkUserPermissions(accessTitanversUserUpsert);
  const handleInviteClick = async () => {
    setSettingsActiveTab("members");
    setShowSettingsModal(true);
    await switchTabWithData("members");
  };

  return (
    <>
      <div className="team-members">
        {teamMemberstoShow?.length > 0 ? (
          teamMemberstoShow?.map((teamMember, index) => (
            <div key={index} className="team-img-text">
              <Tooltip title={teamMember?.userFirstName} arrow>
                <div className="team-img label-btn">
                  {teamMember?.teamMemberImage ? (
                    <img src={teamMember?.teamMemberImage} />
                  ) : (
                    <Avatar
                      name={teamMember?.userFirstName || ""}
                      size={40}
                      fontSize={18}
                    />
                  )}
                </div>
              </Tooltip>
            </div>
          ))
        ) : (
          <div className="team-img-text">
            {headerTeamMembers?.map((member, index) => (
              <Tooltip key={index} title={member?.userFirstName} arrow>
                <div className="team-img label-btn">
                  {member?.teamMemberImage ? (
                    <img
                      src={member?.teamMemberImage}
                      alt={member?.userFirstName}
                    />
                  ) : (
                    <Avatar
                      name={member?.userFirstName || ""}
                      size={40}
                      fontSize={18}
                    />
                  )}
                </div>
              </Tooltip>
            ))}
          </div>
        )}

        {teamMemberstoHide?.length > 0 ? (
          <div className="team-member-count">
            <Tooltip title={teamMemberstoHide?.length + "+ others"} arrow>
              <div className="team-length label-btn">
                <p>{teamMemberstoHide?.length}</p>
              </div>
            </Tooltip>
          </div>
        ) : (
          <></>
        )}
        <Tooltip title="Invite team members" arrow>
          <div
            className="team-member-add"
            onClick={() => {
              if (!hasUserPermission) {
                setShowPermissionMessage("Create or update user");
                setShowPermissionModal(true);
                return;
              }

              handleInviteClick();
            }}
          >
            <div className="team-add label-btn">
              <FaPlus className="para_color" size={12} />
            </div>
          </div>
        </Tooltip>
      </div>
    </>
  );
}
